import { validateChecklist, validateTipslist, validateQuestionlist, validateNewsSignup } from "base/form-validation";
import { eloquaParams } from "base/popups";
import { appendLoader, removeLoader } from "base/my-content";
function checklistSubmit(token, index) {
    event.preventDefault();
    const splitTest = jQuery(`#wm-form__checklistSignup${index}`).parent('[data-splittest]');
    if (splitTest.length > 0) {
        const splitTestEventAndId = jQuery(splitTest).attr('data-split-test-id').split('--');
        if (splitTestEventAndId.length == 2) {
            dataLayer.push({ 'event': splitTestEventAndId[0], 'split-test-id': splitTestEventAndId[1] });
        }
    }
    let formIsValid = false;
    let fieldset = document.querySelector(`#wm-form__checklistSignup${index}`);
    let validForm = validateChecklist.validateAll(fieldset);
    if (validForm.length <= 0)
        formIsValid = true;
    if (formIsValid) {
        appendLoader(".wm-form__submitColumn");
        submitFormToEloqua(`wm-form__checklistSignup${index}`);
        clearForm(`wm-form__checklistSignup${index}`);
    }
}
function questionListSubmit(token) {
    event.preventDefault();
    let formIsValid = false;
    let fieldset = document.querySelector('#wm-form__questionListSignup');
    let validForm = validateQuestionlist.validateAll(fieldset);
    if (validForm.length <= 0)
        formIsValid = true;
    if (formIsValid) {
        appendLoader(".wm-form__submitColumn");
        submitFormToEloqua("wm-form__questionListSignup");
        clearForm("wm-form__questionListSignup");
    }
}
function tipsListSubmit(token) {
    event.preventDefault();
    let formIsValid = false;
    let fieldset = document.querySelector('#wm-form__tipsListSignup');
    let validForm = validateTipslist.validateAll(fieldset);
    if (validForm.length <= 0)
        formIsValid = true;
    if (formIsValid) {
        appendLoader(".wm-form__submitColumn");
        submitFormToEloqua("wm-form__tipsListSignup");
        clearForm("wm-form__tipsListSignup");
    }
}
function newsSignupSubmit(token, index) {
    event.preventDefault();
    const splitTest = jQuery(`#wm-form__newsSignup${index}`).parent('[data-splittest]');
    if (splitTest.length > 0) {
        const splitTestEventAndId = jQuery(splitTest).attr('data-split-test-id').split('--');
        if (splitTestEventAndId.length == 2) {
            dataLayer.push({ 'event': splitTestEventAndId[0], 'split-test-id': splitTestEventAndId[1] });
        }
    }
    let formIsValid = false;
    let fieldset = document.querySelector(`#wm-form__newsSignup${index}`);
    let validForm = validateNewsSignup.validateAll(fieldset);
    if (validForm.length <= 0)
        formIsValid = true;
    if (formIsValid) {
        appendLoader(".wm-form__submitColumn");
        submitFormToEloqua(`wm-form__newsSignup${index}`);
        clearForm(`wm-form__newsSignup${index}`);
    }
}
async function getEloquaHoneypotField() {
    const response = await fetch('/wp-json/eloqua/v1/check');
    if (response.status !== 200) {
        throw new Error(response.statusText);
    }
    return await response.json();
}
export function submitFormToEloqua(id) {
    const formElement = document.getElementById(id);
    if (!formElement) {
        console.error("Form element with ID", id, "not found.");
        return;
    }
    const formData = new FormData(formElement);
    getEloquaHoneypotField()
        .then((honeyPot) => {
        formData.append(honeyPot.fieldName, honeyPot.fieldValue);
        const xhr = new XMLHttpRequest();
        xhr.open("POST", eloquaParams.url, true);
        xhr.onload = function () {
            if (xhr.status === 200) {
                console.log("Form submission successful.");
                let formId = document.getElementById(id);
                if (id !== 'wm-form__tempSignupForm') {
                    let successResponse = formId.querySelector('.wm-form__successResponse');
                    successResponse.classList.add('-show');
                    removeLoader(".wm-form__submitColumn .loader");
                    setTimeout(function () {
                        successResponse.classList.remove('-show');
                    }, 10000);
                }
            }
            else {
                console.log("Form submission failed.");
            }
        };
        xhr.send(formData);
    })
        .catch((e) => {
        console.log(e);
    });
}
export function clearForm(id) {
    let formId = document.getElementById(id);
    formId.reset();
}
window.checklistSubmit = checklistSubmit;
window.questionListSubmit = questionListSubmit;
window.tipsListSubmit = tipsListSubmit;
window.newsSignupSubmit = newsSignupSubmit;
